import type { Vehicle } from '@otw/models'

/** Default cap so Autocomplete does not mount thousands of inventory rows. */
export const VEHICLE_LINK_OPTION_LIMIT = 50

const vehicleLinkSearchHaystack = (vehicle: Vehicle): string =>
  [
    vehicle.stock_number,
    vehicle.year?.toString(),
    vehicle.make,
    vehicle.model,
    vehicle.size,
    vehicle.vin,
  ]
    .map(part => part?.toString().trim())
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

/**
 * Filter vehicles by stock, VIN, year/make/model/size for expense link Autocomplete.
 * Caps results so full inventory (including sold) does not freeze the listbox.
 */
export const filterVehicleLinkOptions = (
  options: readonly Vehicle[],
  inputValue: string,
  opts?: { limit?: number },
): Vehicle[] => {
  const limit = opts?.limit ?? VEHICLE_LINK_OPTION_LIMIT
  const q = inputValue.trim().toLowerCase()
  if (!q) {
    return options.slice(0, limit)
  }
  return options
    .filter(vehicle => vehicleLinkSearchHaystack(vehicle).includes(q))
    .slice(0, limit)
}
